module.exports = __webpack_public_path__ + "static/media/Espro_6.d58677cd.webp";